import { ArrowDownward } from '@mui/icons-material';
import React from 'react';
import "../../css/About.css";
import abSiddik from "../../images/about.jpg";
const About = () => {
    return (
        <div className="about container">
            <div className="about__container">
                <div data-aos="fade-up" data-aos-delay="300" className="about__left">
                    <img className="img-fluid" src={abSiddik} alt="ab-siddik" />
                </div>
                <div data-aos="fade-down" data-aos-delay="300" className="about__right">
                    <h1 className="about__right__heading">ABOUT ME </h1>
                    <p className="about__right__des">My name is Abu Bakkar Siddik. I am a Frontend Web Developer, and I'm very passionate and dedicated to my work.
                        With 2 years experience as a professional Frontend Web developer. </p>
                    <div className="about__right__details">
                        <div className="details">
                            <span>Name: </span> <span>Abu Bakkar Siddik </span>
                        </div>

                        <div className="details">
                            <span>Address: </span> <span>Dhaka, Bangladesh. </span>
                        </div>

                        <div className="details">
                            <span>Github : </span> <span> <a rel="noreferrer" target="_blank" href="https://github.com/developersidd">Go to my github </a>  </span>
                        </div>
                    </div>
                    {/*<button className="about__right__btn">Download Resume</button>*/}
                    <a className="about__right__btn" href="https://drive.google.com/file/d/1PwV7raDyzu1nW_LV10C1On01IG91olEj/view" target="_blank" rel="noreferrer"><ArrowDownward />  Resume </a>
                </div>
            </div>
        </div>
    )
}
export default About;